
import {css} from 'lit';
// eslint-disable-next-line import/prefer-default-export
export const style = css`/**
 * @tokens Hidden
 */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter FontWeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter LineHeight */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/* @presenter FontSize */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * @tokens Padding Sizes
 * @presenter Spacing
 */
/**
 * @tokens Border Radiuses
 * @presenter BorderRadius
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
/**
 * Padding Sizes
 */
/**
 * Border Radiuses
 */
/**
 * @tokens Hidden
 */
/**
 * Border / offset sizes
 */
.error-holder {
  display: none;
}
.error-holder .error-icon-holder {
  flex-shrink: 0;
  flex-grow: 0;
}
.error-holder .error-icon-holder .icon-wrapper {
  margin-top: 4px;
  margin-right: 4px;
}
.error-holder .validation-error-messages,
.error-holder .custom-validation-error-messages {
  font-family: "Open Sans";
  font-size: var(--slh-base-xxs-font-size, 12px);
  font-style: normal;
  font-weight: var(--slh-base-semi-bold-font-weight, 600);
  line-height: var(--slh-base-xxs-line-height, 24px);
  color: #DD5350;
  display: none;
  word-wrap: break-word;
}
.error-holder .custom-validation-error-messages p {
  margin: 0;
}
`;
